import React, { useState } from "react";
import { UploadCloud, CheckCircle2, AlertTriangle, FileCheck2 } from "lucide-react";
import { api } from "../../services/api";

const SAMPLES = [
  { plate: "MH20FU8968", label: "MH20FU8968 — reconciles cleanly" },
  { plate: "DL01XY9876", label: "DL01XY9876 — cylinder mismatch exception" },
];

export default function RVPrevalidate() {
  const [plate, setPlate] = useState("MH20FU8968");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (p) => {
    setBusy(true); setRes(null);
    await new Promise((r) => setTimeout(r, 700));
    const d = await api.rvPrevalidate(p);
    setRes(d); setBusy(false);
  };

  return (
    <div className="rv-preval" data-testid="rv-prevalidate-page">
      <div className="vans-eyebrow" style={{ color: "#b91c1c" }}>IGL · Refuel Validation · Driver & Fleet</div>
      <h1 className="vans-title" style={{ margin: "4px 0 6px" }}>Pre-validate my CNG vehicle</h1>
      <p className="vans-sub" style={{ maxWidth: 720, marginBottom: 18 }}>
        Submit vehicle registration and hydro-test documents before visiting a station. DotIQ extracts the identifiers,
        reconciles them against authoritative records, and returns <b>Pre-validated</b> or <b>Verification required</b>.
      </p>

      <div className="rv-form">
        <label className="rv-field">
          <span>Vehicle registration</span>
          <select value={plate} onChange={(e) => setPlate(e.target.value)} data-testid="rv-preval-plate">
            {SAMPLES.map((s) => <option key={s.plate} value={s.plate}>{s.label}</option>)}
          </select>
        </label>
        <div className="rv-uploads">
          {["RC", "Hydro-test certificate", "CNG installation record"].map((u) => (
            <div key={u} className="rv-upload"><UploadCloud size={16} /> {u} <span className="rv-upload-tag">sample attached</span></div>
          ))}
        </div>
        <button className="btn-primary" onClick={() => submit(plate)} disabled={busy} data-testid="rv-preval-submit">
          <FileCheck2 size={16} /> {busy ? "Reconciling records…" : "Reconcile & pre-validate"}
        </button>
      </div>

      {busy && <div className="loading-page">Extracting identifiers → reconciling against VAHAN / PESO records…</div>}

      {res && (
        <div className="rv-preval-result" data-testid="rv-preval-result">
          <div className="rv-card-h">Extracted information</div>
          <dl className="rv-dl wide">
            <div><dt>Vehicle</dt><dd>{res.plate}</dd></div>
            <div><dt>Cylinder</dt><dd>{res.uploaded_cylinder || (res.extracted && res.extracted.cylinder) || "—"}</dd></div>
            <div><dt>Certificate</dt><dd>{res.certificate || (res.extracted && res.extracted.certificate) || "—"}</dd></div>
            {res.test_date && <div><dt>Test date</dt><dd>{res.test_date}</dd></div>}
            {res.next_due && <div><dt>Next test</dt><dd>{res.next_due}</dd></div>}
          </dl>

          {res.result === "reconciled" ? (
            <div className="rv-preval-ok"><CheckCircle2 size={18} /> Records reconciled — vehicle pre-validation complete.</div>
          ) : (
            <div className="rv-preval-warn">
              <AlertTriangle size={18} /> Verification required
              <p>{res.reason}{res.registry_cylinder ? ` (registry: ${res.registry_cylinder}, uploaded: ${res.uploaded_cylinder})` : ""}</p>
            </div>
          )}
        </div>
      )}

      <footer className="vans-foot">DotIQ × IGL — Refuel Validation POC · fleets can submit vehicles in bulk and see upcoming expirations, missing records and configuration exceptions.</footer>
    </div>
  );
}
